import { SearchRequestBaseModel } from "./SearchRequestModel";

/** Cash payment intent as shown on the Merchant Portal cash-operations screen (TNPDEVAPPS-1755). */
export interface CashOperation {
    id: string;
    tenantId: string;
    externalRef: string;
    amount: number;
    currency: string;
    fee?: number;
    status: string;
    cashDirection: string;
    paymentCode?: string;
    provider?: string;
    providerRef?: string;
    branchCode?: string;
    customerNumber?: string;
    accountNumber?: string;
    individualId?: number;
    epayStatus?: string;
    reviewed: boolean;
    failureReason?: string;
    flexCubeTransactionReference?: string;
    executingOperatorId?: number;
    createdAt: string;
    updatedAt: string;
    expiresAt?: string;
    canRetry: boolean;
}

/** Filter/paging request posted to the adapter's cash-operations search endpoint. */
export class CashOperationsSearchRequest extends SearchRequestBaseModel {
    status?: string;
    cashDirection?: string;
    search?: string;
}
